import React from 'react';
import Icon from '../../../components/AppIcon';

const TrustSignals = () => {
  const certifications = [
    {
      name: "BICSI Certified",
      description: "Building Industry Consulting Service International",
      icon: "Award"
    },
    {
      name: "OSHA Compliant",
      description: "Occupational Safety and Health Administration",
      icon: "Shield"
    },
    {
      name: "FCC Licensed",
      description: "Federal Communications Commission",
      icon: "Radio"
    },
    {
      name: "ISO 9001:2015",
      description: "Quality Management Systems",
      icon: "CheckCircle"
    }
  ];

  const guarantees = [
    {
      title: "Response Time Guarantee",
      description: "We respond to all consultation requests within 2 business hours",
      icon: "Clock",
      highlight: "2 Hours"
    },
    {
      title: "No-Obligation Assessment",
      description: "Complete site assessment with no commitment required",
      icon: "Eye",
      highlight: "Free"
    },
    {
      title: "Transparent Pricing",
      description: "All costs clearly outlined with no hidden fees",
      icon: "DollarSign",
      highlight: "No Hidden Fees"
    },
    {
      title: "Satisfaction Guarantee",
      description: "100% satisfaction guarantee on all consultation services",
      icon: "ThumbsUp",
      highlight: "100%"
    }
  ];

  const recentActivity = [
    {
      type: "consultation",
      company: "TechCorp Solutions",
      location: "San Francisco, CA",
      timeAgo: "2 hours ago",
      status: "completed"
    },
    {
      type: "project",
      company: "Healthcare Partners",
      location: "Austin, TX",
      timeAgo: "5 hours ago",
      status: "started"
    },
    {
      type: "consultation",
      company: "Manufacturing Inc",
      location: "Chicago, IL",
      timeAgo: "1 day ago",
      status: "scheduled"
    },
    {
      type: "project",
      company: "Financial Services LLC",
      location: "New York, NY",
      timeAgo: "2 days ago",
      status: "completed"
    }
  ];

  return (
    <div className="space-y-8">
      {/* Certifications */}
      <div className="bg-white rounded-lg shadow-brand-moderate p-6">
        <h3 className="text-lg font-semibold text-text-primary mb-4 flex items-center">
          <Icon name="Award" size={20} className="mr-2 text-primary" />
          Industry Certifications
        </h3>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {certifications?.map((cert, index) => (
            <div key={index} className="flex items-center space-x-3 p-3 bg-muted/50 rounded-lg">
              <Icon name={cert?.icon} size={20} className="text-primary" />
              <div>
                <h4 className="font-medium text-text-primary text-sm">{cert?.name}</h4>
                <p className="text-xs text-text-secondary">{cert?.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* Guarantees */}
      <div className="bg-white rounded-lg shadow-brand-moderate p-6">
        <h3 className="text-lg font-semibold text-text-primary mb-4 flex items-center">
          <Icon name="Shield" size={20} className="mr-2 text-accent" />
          Our Guarantees
        </h3>
        <div className="space-y-4">
          {guarantees?.map((guarantee, index) => (
            <div key={index} className="flex items-start space-x-4 p-4 border border-border rounded-lg hover:shadow-brand-subtle transition-shadow duration-200">
              <div className="flex-shrink-0">
                <Icon name={guarantee?.icon} size={20} className="text-accent" />
              </div>
              <div className="flex-1">
                <div className="flex items-center justify-between mb-1">
                  <h4 className="font-medium text-text-primary">{guarantee?.title}</h4>
                  <span className="text-sm font-semibold text-accent bg-accent/10 px-2 py-1 rounded">
                    {guarantee?.highlight}
                  </span>
                </div>
                <p className="text-sm text-text-secondary">{guarantee?.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
      {/* Recent Activity */}
      <div className="bg-white rounded-lg shadow-brand-moderate p-6">
        <h3 className="text-lg font-semibold text-text-primary mb-4 flex items-center">
          <Icon name="Activity" size={20} className="mr-2 text-primary" />
          Recent Activity
        </h3>
        <div className="space-y-3">
          {recentActivity?.map((activity, index) => (
            <div key={index} className="flex items-center justify-between p-3 bg-muted/30 rounded-lg">
              <div className="flex items-center space-x-3">
                <div className={`w-2 h-2 rounded-full ${
                  activity?.status === 'completed' ? 'bg-accent' :
                  activity?.status === 'started'? 'bg-primary' : 'bg-warning'
                }`} />
                <div>
                  <p className="text-sm font-medium text-text-primary">
                    {activity?.company}
                  </p>
                  <p className="text-xs text-text-secondary">
                    {activity?.location} • {activity?.type}
                  </p>
                </div>
              </div>
              <div className="text-right">
                <p className="text-xs text-text-secondary">{activity?.timeAgo}</p>
                <span className={`text-xs px-2 py-1 rounded-full ${
                  activity?.status === 'completed' ? 'bg-accent/10 text-accent' :
                  activity?.status === 'started'? 'bg-primary/10 text-primary' : 'bg-warning/10 text-warning'
                }`}>
                  {activity?.status}
                </span>
              </div>
            </div>
          ))}
        </div>
        <div className="mt-4 text-center">
          <p className="text-sm text-text-secondary">
            <Icon name="TrendingUp" size={16} className="inline mr-1" />
            <strong>47</strong> consultations completed this month
          </p>
        </div>
      </div>
    </div>
  );
};

export default TrustSignals;